import React from "react";
import { ValidationErrors } from "src/errors";
import { AuthFormAction, AuthFormData, AuthFormDataKey } from "src/types";
import {
  AuthSignIn,
  AuthConfirmSignUp,
  AuthCustomChallenge,
  AuthForgotPassword,
  AuthForgotPasswordSubmit,
  AuthRequestAccountCreation,
  AuthSignUp
} from "./";

interface AuthFormProps {
  action: AuthFormAction;
  formData: AuthFormData;
  validationErrors?: ValidationErrors<AuthFormDataKey>;
  formLvlErrorMessage: string;
  setAction: (action: AuthFormAction) => void;
  handleInputChange: (field: AuthFormDataKey, value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const AuthForm: React.FC<AuthFormProps> = ({
  action,
  formData,
  validationErrors,
  formLvlErrorMessage,
  setAction,
  handleInputChange,
  handleSubmit
}) => {
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      {action === "SIGN_IN" && (
        <AuthSignIn
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
        />
      )}
      {(action === "CUSTOM_CHALLENGE" || action === "RESEND_CUSTOM_CHALLENGE") && (
        <AuthCustomChallenge
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
          setAction={setAction}
        />
      )}
      {action === "SIGN_UP" && (
        <AuthSignUp
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
        />
      )}
      {(action === "CONFIRM_SIGN_UP" || action === "RESEND_SIGN_UP") && (
        <AuthConfirmSignUp
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
          setAction={setAction}
        />
      )}
      {action === "FORGOT_PASSWORD" && (
        <AuthForgotPassword
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
        />
      )}
      {action === "FORGOT_PASSWORD_SUBMIT" && (
        <AuthForgotPasswordSubmit
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
          setAction={setAction}
        />
      )}
      {action === "REQUEST_ACCOUNT_CREATION" && (
        <AuthRequestAccountCreation
          formData={formData}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
          handleInputChange={handleInputChange}
        />
      )}
    </form>
  );
};

export { AuthForm };
